import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styles from '../styles.module.scss';

const QuantityHeader = ({ translationKey }) => {
  const [t] = useTranslation();
  return (
    <>
      <div className={`d-flex`}>
        <span
          className={`d-block my-0 ${styles['table-header-text']}
          }`}
        >
          {t(translationKey)}
        </span>
      </div>
    </>
  );
};

QuantityHeader.propTypes = {
  translationKey: PropTypes.string
};

export default QuantityHeader;
